import toastStyle from "../../styles/toaster.module.css";
import { ReactComponent as ErrorCloseIcon } from "../../assets/icons/close_red.svg";
import { ReactComponent as SuccessCloseIcon } from "../../assets/icons/close_purple.svg";

const ToastNotification = ({
  title,
  children,
  removeError,
  variant = "error",
}: {
  title: string;
  children: React.ReactNode;
  removeError: () => void;
  variant?: "success" | "error" | "pending";
}) => {
  const toastClass =
    variant === "success" || variant === "pending"
      ? `${toastStyle.toast} ${toastStyle.success}`
      : toastStyle.toast;

  return (
    <div className={toastClass}>
      <div className="flex justify-between">
        <h3 className={toastStyle.toastTitle}>{title}</h3>
        <button onClick={() => removeError()}>
          {variant === "success" || variant === "pending" ? (
            <SuccessCloseIcon />
          ) : (
            <ErrorCloseIcon />
          )}
        </button>
      </div>
      {children}
    </div>
  );
};

export default ToastNotification;
